<template>
	<div class="flex h-full w-full items-center justify-center">
		<div class="flex w-80 max-w-full flex-col items-center">
			<LogoSimpleIcon class="h-4.5" />
			<div
				class="font-squad text-label-primary mt-6 w-full text-center text-2xl font-black uppercase"
			>
				{{ t('title') }}
			</div>
			<div class="text-label-secondary mt-3 w-full text-center text-sm">
				{{ t('desc') }}
			</div>
			<BaseButton
				size="lg"
				color="primary"
				class="mt-6 w-full"
				as="a"
				href="https://t.me/ragegiftbot/app?startapp=r-RAGE"
			>
				{{ t('btn') }}
			</BaseButton>
		</div>
	</div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BaseButton from './BaseButton.vue'
import LogoSimpleIcon from '@/assets/icons/logo-simple.svg'

const { t } = useI18n({
	messages: {
		en: {
			title: 'Not available in web',
			desc: 'Rage.gift is currently in open beta and is temporarily available only through our Telegram web app.',
			btn: 'Open web app'
		},
		ru: {
			title: 'Недоступно в вебе',
			desc: 'Rage.gift находится на стадии открытого бета-тестирования и временно доступен только через наш веб-апп в Telegram.',
			btn: 'Открыть веб-апп'
		}
	}
})
</script>
